'use strict';
const hasMissingScopes = require('./has-missing-scopes'),
	safeJSONParse = require('@mindmup/js-utils/src/safe-json-parse');
//TODO: inject PKCEUtils instead of instantiating them here!
module.exports = function OAuthPKCEShim({scope, clientId, endpointUrl, storageKey, navigatorShim, pkceUtils, popupLauncher, ajaxPromise, messagePrefix = 'oauth-authenticated#', interactionRequiredErrors = [], logger} = {}) {
	if (!scope || !clientId || !endpointUrl || !storageKey || !navigatorShim || !ajaxPromise || !messagePrefix || !popupLauncher || !pkceUtils) {
		throw new Error('invalid-args');
	}
	if (!Array.isArray(interactionRequiredErrors)) {
		throw new Error('invalid-args');
	}
	const storage = navigatorShim.getJsonStorage(),
		//pkceUtils = new PKCEUtils({navigatorShim, clientId, interactionRequiredErrors, ajaxPromise, endpointUrl, logger}),
		calculateScopes = (params) => {
			if (!params) {
				return scope;
			}
			const {additionalScopes} = params;
			return [scope].concat(additionalScopes || []).join(' ');
		},
		validateCachedToken = async (params) => {
			const lastAuthResponse = storage.getItem(storageKey),
				requiredScopes =  calculateScopes(params);
			if (!lastAuthResponse) {
				throw 'not-authenticated';
			}
			if (lastAuthResponse.expiry < Date.now()) {
				throw 'not-authenticated';
			}
			if (hasMissingScopes(lastAuthResponse.scope, requiredScopes)) {
				throw 'not-authenticated';
			}
			if (!lastAuthResponse.accessToken) {
				throw 'not-authenticated';
			}
			return lastAuthResponse.accessToken;
		},
		storeAuthResponse = async (authResponse) => {
			storage.setItem(storageKey, {
				accessToken: authResponse.access_token,
				expiry: Date.now() + parseInt(authResponse.expires_in) * 1000,
				scope: authResponse.scope,
				refreshToken: authResponse.refresh_token
			});
		},
		signOut = async () => {
			storage.remove(storageKey);
		},
		processAuthResponse = (authResponse = {}, requiredScopes) => {
			if (authResponse.error && interactionRequiredErrors.includes(authResponse.error)) {
				logger?.error(authResponse);
				throw 'popup-auth-required';
			} else if (authResponse.error) {
				logger?.error(authResponse);
				throw 'not-authenticated';
			}
			if (!authResponse.access_token || !authResponse.expires_in) {
				throw 'network-error';
			}
			if (hasMissingScopes(authResponse.scope, requiredScopes)) {
				throw 'not-authenticated';
			}
			storeAuthResponse(authResponse);
		},
		authorize = async (params = {}) => {
			try {
				const {code, verifier, state} = pkceUtils.createChallenge(),
					requiredScopes = calculateScopes(params),
					redirectUri = navigatorShim.getOrigin() + '/oauth-authenticated.html',
					url = pkceUtils.createPKCEURL({code, state, requiredScopes, endpointUrl, optional: params, redirectUri}),
					pkceResponse = await popupLauncher.openAndWaitForMessage(url, messagePrefix),
					authResponse = await pkceUtils.completePKCEFlow({pkceResponse, state, verifier, endpointUrl, requiredScopes, redirectUri});
				processAuthResponse(authResponse, requiredScopes);
				return authResponse.access_token;
			} catch (e) {
				logger?.error(e);
				if (typeof e === 'string') {
					throw e;
				}
				throw 'not-authenticated';
			}
		},
		refreshToken = async (params) => {
			const lastAuthResponse = storage.getItem(storageKey),
				requiredScopes = calculateScopes(params),
				lastRefreshToken = lastAuthResponse?.refreshToken;
			if (!lastRefreshToken) {
				throw 'not-authenticated';
			}
			try {
				const tokenRequest = {
						'tenant': 'common', //MS-Specific
						'scope': requiredScopes, // MS-Specific
						'grant_type': 'refresh_token',
						'refresh_token': lastRefreshToken,
						'client_id': clientId
					},
					authResponse = await ajaxPromise.request({
						type: 'POST',
						url: endpointUrl + 'token',
						headers: {'Content-Type': 'application/x-www-form-urlencoded'},
						data: new URLSearchParams(tokenRequest).toString()
					});
				processAuthResponse(
					Object.assign({refresh_token: lastRefreshToken}, authResponse),
					requiredScopes
				);
				return authResponse.access_token;
			} catch (e) {
				logger?.error(e);
				if (typeof e === 'string') {
					storage.remove(storageKey);
					throw e;
				}
				if (typeof e?.responseText === 'string') {
					const response = safeJSONParse(e.responseText);
					if (response) {
						processAuthResponse(response, requiredScopes);
					}
				}
				throw 'not-authenticated';
			}
		};
	Object.freeze(Object.assign(this, {
		validateCachedToken,
		refreshToken,
		storeAuthResponse,
		authorize,
		signOut
	}));
};
